import { type RefObject, useEffect } from "react";
import { useDataTableContext } from "./context";

/** Props Interface */
interface DataTableScrollHandlerProps {
	tableContainerRef: RefObject<HTMLDivElement | null>;
	isLoading: boolean;
}

export function DataTableScrollHandler({
	tableContainerRef,
	isLoading,
}: DataTableScrollHandlerProps) {
	/** Context */
	const { table } = useDataTableContext();

	const { pagination } = table.state;

	/** Effects */
	useEffect(() => {
		if (isLoading) return;
		if (tableContainerRef.current) {
			tableContainerRef.current.scrollTop = 0;
		}
	}, [pagination.pageIndex, isLoading]);

	/** Render */
	return null;
}
